import React, { Component } from "react"
import config from "react-global-configuration"
import * as dateHelper from "../../helpers/date"
import { getCssLegend } from "../../helpers/bookingHelper"

class ReceiptBookingProducts extends Component {
  renderItems(item, variant, key, price) {
    return (
      <li key={key}>
        <h3>
          {item.name}
          {variant && variant.name !== item.name ? ` - ${variant.name}` : ""}
        </h3>
        <h4> {this.props.priceFormatter(price)}</h4>
      </li>
    )
  }

  getExtraOfferLinePrice = (offerLine, booking) => {
    if (!offerLine) return 0
    if (!booking) return 0
    return offerLine.priceOffer.amount
  }

  renderExtraItems(extra, i) {
    const sortedVariants = extra.variants.slice().sort((a, b) => {
      const aPrice = this.getExtraOfferLinePrice(a, this.props.bookingResult.booking)
      const bPrice = this.getExtraOfferLinePrice(b, this.props.bookingResult.booking)
      return aPrice > bPrice ? 1 : -1
    })
    return (
      <React.Fragment key={extra.product.name + i}>
        {sortedVariants.map((variant, index) => {
          const price = this.getExtraOfferLinePrice(variant, this.props.bookingResult.booking)
          return (
            <li key={variant.productOffer.name + index}>
              <h3>
                {extra.product.name}
                {variant && variant.productOffer.name !== extra.product.name ? ` - ${variant.productOffer.name}` : ""}
              </h3>
              <h4> {this.props.priceFormatter(price)}</h4>
            </li>
          )
        })}
      </React.Fragment>
    )
  }

  formatDate(date, time, timeLabel) {
    return dateHelper.formatDate(date, "DD MMM. YYYY") + ` ${timeLabel ?? ""} ` + time
  }

  render() {
    const { booking, product, carPark, extras, noLastStyling, isCancelled, activeBookingExtraProducts, parking, bookingResult } = this.props
    let parkingPrice = parking.originalAmount ?? parking.amount // fallback to amount if originalAmount is null
    if (booking.promotionCode && booking.promotionSaving > 0) {
      parkingPrice = parking.originalAmount
    } else if (!!booking.affiliateCode && !booking.useMemberPrice && parking.amount < parking.originalAmount) {
      parkingPrice = parking.amount
    } else if (booking.useMemberPrice) {
      parkingPrice = parking.amount
    } else if (parking.isParkingUpgrade || bookingResult.bookingHistory?.parentBooking.isEmailUpgrade) {
      // if current or parent booking was an upgrade
      parkingPrice = parking.amount
    }
    const parkingLegend = getCssLegend(carPark.name, product.name)

    const summaryCheckoutTextKeys = config.get("textKeys.checkout.summary") || {}
    const listTextKeys = config.get("textKeys.extraServices.list") || {}
    const productDetailsTextKeys = config.get("textKeys.parkingList.detailsModal") || {}
    const mainCheckoutTextKeys = config.get("textKeys.checkout.main") || {}

    const geoLocation = `https://www.google.com/maps/dir/?api=1&destination=${carPark.latitude},${carPark.longitude}&travelmode=driving`

    const thirdPartyPromoLabel = booking?.thirdPartyPromoLabelText

    let sortedExtraProducts = []
    if (activeBookingExtraProducts && activeBookingExtraProducts.length > 0) {
      sortedExtraProducts = activeBookingExtraProducts.slice().sort((a, b) => (a.product.id > b.product.id ? 1 : -1))
    }

    return (
      <div className="parking-receipt__middle">
        <ul className="parking-receipt__middle__calc">
          <li>
            <div>
              <span className={`parking-legend__item parking-legend__item--square parking-legend__item--${parkingLegend}`}>{carPark.name}</span>
              <h5>{`${product.name}${thirdPartyPromoLabel ? ` ${thirdPartyPromoLabel}` : ""}`}</h5>
            </div>
            <h4>{this.props.priceFormatter(parkingPrice)}</h4>
          </li>
          <li>
            <p>
              {this.formatDate(booking.arrivalDate, booking.arrivalTime, summaryCheckoutTextKeys.labelBeforeTime)} -{" "}
              {this.formatDate(booking.departureDate, booking.departureTime, summaryCheckoutTextKeys.labelBeforeTime)}
              <a href={geoLocation} target="_blank" rel="noreferrer">
                {productDetailsTextKeys.wayFinding || "Find vej til "} {carPark.name}
              </a>
            </p>
          </li>
          {sortedExtraProducts.length > 0
            ? sortedExtraProducts.map((extra, index) => {
                return this.renderExtraItems(extra, index)
              })
            : ""}
          {!booking.promotionCode || booking.promotionSaving === 0 ? (
            ""
          ) : (
            <li>
              <p>
                {summaryCheckoutTextKeys.promotionCode || "Kampagnekode"}: {booking.promotionName}
              </p>
              <h4>-{this.props.priceFormatter(booking.promotionSaving)}</h4>
            </li>
          )}
        </ul>
        <div className="parking-receipt__middle__total">
          <h4>
            {mainCheckoutTextKeys.total} {this.props.priceFormatter(booking.price)}
          </h4>
        </div>
      </div>
    )
  }
}
export default ReceiptBookingProducts
